import React from 'react';
import { PopupHuchaCardContainer2 } from '../../../ui/popup-hucha-card-container';
import { PopupHuchaBonusCardC2 } from './popup-hucha-bonus-card-c2';
import { PopupHuchaBonusCardC3 } from './popup-hucha-bonus-card-c3';

export const PopupHuchaBonusCard: React.FC<{
	dineroHucha: string;
}> = ({ dineroHucha }) => {
	return (
		<PopupHuchaCardContainer2>
			<PopupHuchaBonusCardC2 />
			<PopupHuchaBonusCardC3 dineroHucha={dineroHucha} />
		</PopupHuchaCardContainer2>
	);
};
